










































































import { PropType } from 'vue';
import { mapActions } from 'vuex';
import { setErrorFromAxiosError } from '@/utils/helpers';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';

import { ISystemError } from '@/models/error/error.types';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePaymentStatusEnum
} from '@/models';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import InventoryAdvancePaymentCancelButton from '../common/InventoryAdvancePaymentCancelButton.vue';
import InventoryAdvancePaymentCurrentAssigneePicker from '../common/InventoryAdvancePaymentCurrentAssigneePicker.vue';

import InventoryAdvancePaymentStateTransitionCommentFormDialog from '../common/InventoryAdvancePaymentStateTransitionCommentFormDialog.vue';

const baseMixins = mixins(authMixin);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    commentDialog: InstanceType<
      typeof InventoryAdvancePaymentStateTransitionCommentFormDialog
    >;
  };
}
export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'InventoryAdvancePaymentFinanceManagerAssignedStateCardActions',

    components: {
      InventoryAdvancePaymentCancelButton,
      ConfirmationDialog,
      InventoryAdvancePaymentCurrentAssigneePicker,
      InventoryAdvancePaymentStateTransitionCommentFormDialog
    },

    props: {
      inventoryAdvancePayment: {
        type: Object as PropType<IInventoryAdvancePayment>
      }
    },

    data() {
      return {
        isLoading: false,
        error: null as ISystemError | null,

        isAssigneeDialogActive: false,
        assignee: null
      };
    },

    methods: {
      ...mapActions({
        updateInventoryAdvancePaymentState:
          'inventoryAdvancePayment/updateInventoryAdvancePaymentState',
        fetchInventoryAdvancePaymentActivities:
          'inventoryAdvancePayment/fetchInventoryAdvancePaymentActivities'
      }),

      /**
       * @see api inventoryAdvancePayment/models/start_processing_invoice
       * can be called only from states:
       * - InventoryAdvancePaymentStatusEnum.RequestProcessed
       *
       * can go to state
       * - InventoryAdvancePaymentStatusEnum.Paid
       */
      async assignAPSpecialist(assignee: number) {
        const {
          isConfirmed,
          comment
        } = await this.$refs.commentDialog.openCommentsDialog(
          InventoryAdvancePaymentStatusEnum.APSpecialistAssigned
        );
        if (isConfirmed) {
          this.clearErrors();
          this.isLoading = true;
          this.updateInventoryAdvancePaymentState({
            id: this.inventoryAdvancePayment.id,
            state: InventoryAdvancePaymentStatusEnum.APSpecialistAssigned,
            assignee: assignee,
            comment: comment
          })
            .then(() => {
              this.$emit('assignAPSpecialist');
              this.fetchInventoryAdvancePaymentActivities(
                this.inventoryAdvancePayment.id
              );
            })
            .catch(error => {
              this.error = setErrorFromAxiosError(error);

              this.$emit('error', error);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      },

      clearErrors() {
        this.error = null;
        this.$emit('clearErrors');
      }
    }
  });
